import React, { useState, useEffect } from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Chip,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Alert,
    Snackbar,
    Avatar,
    Grid,
    Switch,
    InputAdornment
} from '@mui/material';
import {
    Edit,
    Delete,
    Add,
    Person,
    Email,
    Phone,
    AdminPanelSettings,
    Visibility,
    VisibilityOff
} from '@mui/icons-material';
import { createAdminUsers, getAdminUsers, getAdminRoles, editAdminUser, deactivateUser,editSuperAdmin } from '../services/adminUserService';
import CommonModal from '../components/common/CommonModal';
import { useNotification } from '../contexts/NotificationContext';
import outletService from '../services/outletService';

function AdminUsers({ refresh }) {
    const [users, setUsers] = useState([]);
    const [userModalOpen, setUserModalOpen] = useState(false)
    const [userEditData, setUserEditData] = useState({})
    const [toggler, setToggler] = useState(true)
    const [superAdminEditModal, setSuperAdminEditModal] = useState(false)

    const [roles, setRoles] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogMode, setDialogMode] = useState('add'); // 'add' or 'edit'
    const [currentUser, setCurrentUser] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        role: '',
        status: 'Active',
        avatar: null,
    });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const { showSuccess, showError } = useNotification()

    const fetchAdminUsers = async () => {
        try {
            const response = await getAdminUsers();
            // console.log("Admin Users Response => ", response);
            setUsers(response);
        } catch (error) {
            console.error("Error fetching admin users:", error);
            setSnackbar({
                open: true,
                message: 'Failed to fetch admin users',
                severity: 'error'
            });
        }
    };

    const fetchAdminRoles = async () => {
        try {
            const response = await getAdminRoles();
            // console.log("Admin Roles Response => ", response);
            setRoles(response.data);
        } catch (error) {
            console.error("Error fetching admin roles:", error);
        }
    };

    useEffect(() => {
        fetchAdminUsers();
        fetchAdminRoles();
    }, [userModalOpen, refresh, toggler,superAdminEditModal]);


    const handleToggleUser = async (id) => {
        try {
            let data = {
                "user_id": id
            }
            const response = await deactivateUser(data)
            showSuccess(response?.message)
            let updatedToggler = !toggler
            setToggler(updatedToggler)
        }
        catch (error) {
            showError(error?.message)
            let updatedToggler = !toggler
            setToggler(updatedToggler)
        }
    }

    return (
        <Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell sx={{ fontWeight: 'bold' }}>S.No</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Username</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Role</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.length > 0 ? (
                            users.map((user, index) => (
                                <TableRow key={user.id || index} hover>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{user?.username}</TableCell>
                                    <TableCell>{user?.role}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={user?.active}
                                            size="small"
                                            color={user.active === 'Active' ? 'success' : 'default'}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <IconButton size="small" color="primary"
                                            onClick={() => {
                                                if (user.role_id === 1) {
                                                    setSuperAdminEditModal(true)
                                                }
                                                else {
                                                    setUserModalOpen(true)
                                                }
                                                setUserEditData({
                                                    "id": user.id,
                                                    "username": user.username,
                                                    "full_name": user.full_name,
                                                    "role_id": user.role_id,
                                                    "outlet_id": user.outlet_id
                                                })
                                            }
                                            }
                                        >
                                            <Edit fontSize="small" />
                                        </IconButton>
                                        <Switch
                                            size="small"
                                            color="success"
                                            checked={user.active}   // or role.status === "active"
                                            onChange={(e) => handleToggleUser(user.id)}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                                    <Typography variant="body1" color="textSecondary">
                                        No admin users found
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <CommonModal modalOpen={userModalOpen} setModalOpen={setUserModalOpen} children={<UserModal setModalOpen={setUserModalOpen} editUserState={userEditData} />} modalWidth={600} />

            <CommonModal modalOpen={superAdminEditModal} setModalOpen={setSuperAdminEditModal} children={<SuperAdminEditModal setSuperAdminEditModal={setSuperAdminEditModal} editUserState={userEditData} />} modalWidth={600} />
        </Box>
    );
}



const UserModal = ({ setModalOpen, editUserState }) => {

    const [formData, setFormData] = useState({
        "user_id": "",
        "username": "",
        "full_name": "",
        "role_id": "",
        "outlet_id": "",
    })

    const [fields, setFields] = useState([
        { "name": "Username", "value": "username", "required": true, "type": "text" },
        // { "name": "Password", "value": "password", "required": true, "type": "password" },
        { "name": "Full Name", "value": "full_name", "required": false, "type": "text" }
    ])

    const [adminRoles, setAdminRoles] = useState([])
    const [role, setRole] = useState(0)
    const [outlets, setOutlets] = useState([])
    const { showSuccess, showError } = useNotification()

    async function fetchAdminRoles() {
        try {
            const response = await getAdminRoles()
            setAdminRoles(response.data)
            // console.log("Admin Roles => ", response)
        }
        catch (error) {
            console.error(error)
        }
    }

    // console.log("Edit User Data =>", editUserState)
    async function fetchOutlets() {
        try {
            const outletResponse = await outletService.getOutlets()
            setOutlets(outletResponse)
        }
        catch (error) {
            showError("Error While Retrieving Outlets")
        }
    }

    useEffect(() => {
        fetchAdminRoles()
        fetchOutlets()
        setFormData({
            "user_id": editUserState.id,
            "username": editUserState.username,
            "full_name": editUserState.full_name,
            "role_id": editUserState.role_id,
            "outlet_id": editUserState.outlet_id
        })
        setRole(editUserState.role_id)

    }, [])


    const handleInputChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRoleSelect = (value) => {
        setRole(value)
        setFormData(prev => ({
            ...prev,
            ["role_id"]: value
        }));
    }


    const handleOutletSelect = (value) => {
        setFormData(prev => ({
            ...prev,
            ["outlet_id"]: value
        }));
    }

    const handleSubmit = async () => {
        // console.log("Form Data => ", formData)

        if (formData.username === "") {
            showError("Please Enter Username")
            return;
        }

        if (formData.username !== "" && formData.username.length > 20) {
            showError("Please Enter Username Below 20 Characters")
            return;
        }

        if (formData.role_id === "") {
            showError("Please Select Role")
            return;
        }

        if (!formData.outlet_id) {
            showError("Please Select Outlet")
            return;
        }

        if (formData.outlet_id && formData.outlet_id === 0) {
            showError("Please Select Outlet")
            return;
        }


        try {
            const response = await editAdminUser(formData);
            showSuccess(response.message)
            setModalOpen(false)
            setFormData({
                "username": "",
                "full_name": "",
                "role_id": ""
            })
            setAdminRoles(0)
        }
        catch (error) {
            console.error(error)
            showError(error.message)
        }

    }
    return (
        <>
            <Typography variant='h5' sx={{ textAlign: 'center', mb: 2 }}>Update Admin User</Typography>

            <Box>
                <FormControl fullWidth sx={{ mt: 1, mb: 1 }}>
                    <InputLabel id="demo-simple-select-label">Select Role</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={role}
                        label="Select Role"
                        onChange={(e) => handleRoleSelect(e.target.value)}
                    >
                        <MenuItem value={0}>Select Role</MenuItem>
                        {adminRoles.map((role, index) => {
                            return (
                                <MenuItem value={role.id}>{role.role}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>


                <FormControl fullWidth sx={{ mt: 1, mb: 1 }}>
                    <InputLabel id="demo-simple-select-label">Select Outlet</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={formData.outlet_id}
                        label="Select Outlet"
                        onChange={(e) => handleOutletSelect(e.target.value)}
                    >
                        <MenuItem value={0}>Select Outlet</MenuItem>
                        {outlets.map((outlet, index) => {
                            return (
                                <MenuItem value={outlet.id}>{outlet.name}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>

                {fields.map((field, index) => {
                    return (
                        <TextField
                            sx={{ mb: 2, mt: 1 }}
                            fullWidth
                            type={field.type}
                            label={field.name}
                            required={field.required}
                            value={formData[field.value]}
                            onChange={(e) => handleInputChange(field.value, e.target.value)}
                        ></TextField>
                    )
                })}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>Update</Button>
                    <Button variant='outlined' onClick={() => {
                        setModalOpen(false)
                        setFormData({
                            "username": "",
                            "full_name": "",
                            "role_id": ""
                        })
                    }}>Cancel</Button>
                </Box>
            </Box>

        </>
    )


}



const SuperAdminEditModal = ({ setSuperAdminEditModal, editUserState }) => {
    const [formData, setFormData] = useState({
        "username": "",
        "password": "",
        "full_name": "",
    })

    const [fields, setFields] = useState([
        { "name": "Username", "value": "username", "required": true, "type": "text" },
        // { "name": "Password", "value": "password", "required": true, "type": "password" },
        { "name": "Full Name", "value": "full_name", "required": false, "type": "text" }
    ])

    const [showPassword, setShowPassword] = useState(false);

    const { showSuccess, showError } = useNotification()

    useEffect(() => {
        setFormData({
            "user_id":editUserState.id,
            "username": editUserState.username,
            "full_name": editUserState.full_name,
        })
    },[])

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleInputChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        console.log("Form Data => ", formData)

        if (!formData.username) {
            showError("Please Enter Username")
            return;
        }

        if (formData.username === "") {
            showError("Please Enter Username")
            return;
        }

        if (formData.username !== "" && formData.username.length > 20) {
            showError("Please Enter Username Below 20 Characters")
            return;
        }


        // if (formData.password.length < 8) {
        //     showError("Please Enter Password atleast 8 Characters")
        //     return;
        // }




        try {
            
            const response = await editSuperAdmin(formData);
            showSuccess(response.message)
            setSuperAdminEditModal(false)
            setFormData({
                "username": "",
                "full_name": "",
            })
        }
        catch (error) {
            console.error(error)
            showError(error.message)
        }

    }


    return (
        <>
            <Box>
                <Typography variant='h5' sx={{ textAlign: 'center', mb: 2 }}>Update Super Admin</Typography>
                {fields.map((field, index) => {
                    // Determine if this field is a password field
                    const isPasswordField = field.type === 'password';

                    return (
                        <TextField
                            key={index}
                            sx={{ mb: 2, mt: 1 }}
                            fullWidth
                            type={isPasswordField && showPassword ? 'text' : field.type}
                            value={formData[field.value]}
                            label={field.name}
                            required={field.required}
                            onChange={(e) => handleInputChange(field.value, e.target.value)}
                            InputProps={
                                isPasswordField ? {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleTogglePassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                } : {}
                            }
                        />
                    );
                })}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>Update</Button>
                    <Button variant='outlined' onClick={() => setSuperAdminEditModal(false)}>Cancel</Button>
                </Box>
            </Box>

        </>
    )
}
export default AdminUsers;